import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "externalLinkArrow",
  "use": "externalLinkArrow-usage",
  "viewBox": "0 0 31.49 31.49",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 31.49 31.49\" id=\"externalLinkArrow\">\n\t<path fill=\"currentColor\" d=\"M12.013 4.291a1.112 1.112 0 0 0-1.122 1.122A1.12 1.12 0 0 0 12 6.524h11.38L4.606 25.301a1.106 1.106 0 0 0 0 1.572 1.118 1.118 0 0 0 1.583.011L24.965 8.108l-.01 11.37c.01.616.516 1.122 1.122 1.121.627 0 1.133-.505 1.122-1.122V5.403a1.093 1.093 0 0 0-1.111-1.111z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol